import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import DropdownWrapper from "lib/common/components/DropdownWrapper";

class DropDown extends React.Component {
    constructor(props) {
        super(props);
        this.targetRef = React.createRef();
        this.state = {
            showDropdownMenu: false
        };

        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onHide = this.onHide.bind(this);
    }

    onClick(e) {
        e.preventDefault();
        this.setState((s) => ({showDropdownMenu: !s.showDropdownMenu}));
    }

    onKeyDown(e) {
        if(e.target === this.targetRef.current) {
            if([" ", "Space"].includes(e.key)) {
                this.setState((s) => ({showDropdownMenu: !s.showDropdownMenu}));
            }
        }
    }

    onHide() {
        const { onHide } = this.props;
        this.setState({showDropdownMenu: false});
        onHide && onHide();
    }

    render() {
        const {
            title,
            icon,
            label,
            children,
            className,
            onKeyDown,
            align
        } = this.props;
        if (children == null) return null;
        if (Array.isArray(children)) {
            if (children.length === 0) return null;
            if (children.every(it => !it)) return null;
        } else if (!children) {
            return null;
        }
        return <li title={title} className={classnames("dropdown", className)} data-control-type="bootstrap-dropdown" onKeyDown={onKeyDown}>
            <a
                ref={this.targetRef}
                className={"dropdown-toggle"}
                href="#"
                onClick={this.onClick}
                onKeyDown={this.onKeyDown}
            >
                {icon && <span className={`glyphicon glyphicon-${icon}`} />} {label} <b className="caret" />
            </a>
            {this.state.showDropdownMenu && <DropdownWrapper
                targetRef={this.targetRef}
                align={align || "left"}
                layer="navbar"
                scrollSelector="li.active"
                onHide={this.onHide}
                autoSize={false}
            >
                <ul className="dropdown-menu navbar-menu">
                    {children}
                </ul>
            </DropdownWrapper>
            }
        </li>;
    }

}

DropDown.propTypes = {
    title: PropTypes.string,
    label: PropTypes.any,
    icon: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    align: PropTypes.oneOf(["left", "right"]),
    onKeyDown: PropTypes.func,
    onHide: PropTypes.func,
};

export default DropDown;



// WEBPACK FOOTER //
// ./app/views/DropDown.js